import { IMasterLayoutEditService } from '@src/slide/application/service/master-layout-edit-service/master-layout-edit-service.interface';

export class MasterLayoutStyleService {
    private masterLayoutEditService?: IMasterLayoutEditService;

    public setMasterLayoutEditServiceDelegate(masterLayoutEditService: IMasterLayoutEditService): void {
        if (this.masterLayoutEditService) {
            return;
        }
        this.masterLayoutEditService = masterLayoutEditService;
    }

    public getCurEditTypeStyle() {
        return {
            leftBar: this.getCurLeftBarStyle(),
            canvasWrapper: this.getCurCanvasWrapperStyle(),
            groupWrapper: this.getCurGroupWrapperStyle(),
            slideIndex: this.getCurSlideIndexStyle(),
        };
    }

    public getCurLeftBarStyle() {
        if (this.masterLayoutEditService?.isMasterEditType) {
            return {
                // backgroundColor: '#454D5A',
                color: '#fff',
            };
        }
        return {
            // backgroundColor: '#fff',
            color: '#000',
            paddingTop: '4px',
        };
    }

    public getCurCanvasWrapperStyle() {
        if (this.masterLayoutEditService?.isMasterEditType) {
            return this.getLayoutCanvasWrapperStyle();
        }
        return this.getSlideCanvasWrapperStyle();
    }

    public getCurSlideIndexStyle() {
        if (this.masterLayoutEditService?.isMasterEditType) {
            return {
                opacity: 0.5,
                selectedOpacity: 1,
            };
        }
        return {
            opacity: 0.32,
            selectedOpacity: 0.48,
        };
    }

    public getCurGroupWrapperStyle() {
        // if (this.masterLayoutEditService?.isMasterEditType) {
        //     return {
        //         //
        //         // backgroundColor: '#454D5A',
        //         // color: '#fff',
        //     };
        // }
        return {
            paddingTop: 7,
            paddingBottom: 0,
            backgroundColor: 'transparent',
        };
    }

    public getLayoutCanvasWrapperStyle() {
        return {
            borderColor: '#e7e8e9',
            transformOrigin: 'right',
            transformScale: '0.75',
        };
    }

    public getSlideCanvasWrapperStyle() {
        return {
            borderColor: '#e7e8e9',
            transformOrigin: 'center',
            transformScale: '1',
        };
    }
}
